if (!customElements.get('cart-notification')) {
  class CartNotification extends HTMLElement {
    constructor() {
      super();

      this.notification = document.getElementById('cart-notification');
      this.header = document.querySelector('sticky-header');
      this.onBodyClick = this.handleBodyClick.bind(this);

      if (!this.notification) return;

      this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
      this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
        closeButton.addEventListener('click', this.close.bind(this))
      );
    }

    open() {
      if (!this.notification) return;
      this.notification.classList.add('animate', 'active');

      const focusNotification = () => {
        this.notification.focus();
        if (typeof trapFocus === 'function') trapFocus(this.notification);
      };

      this.notification.addEventListener('transitionend', focusNotification, { once: true });
      window.setTimeout(() => {
        if (this.notification.classList.contains('active') && document.activeElement !== this.notification) {
          focusNotification();
        }
      }, 450);

      document.body.addEventListener('click', this.onBodyClick);
      this.refreshCartState();
    }

    async refreshCartState() {
      try {
        const response = await fetch(`${routes.cart_url}.json`, {
          headers: { Accept: 'application/json' },
          credentials: 'same-origin',
        });
        if (!response.ok) return;
        const cart = await response.json();
        this.syncCustomCartCount(cart.item_count || 0);

        const { CartViewEvent } = window.StandardEvents || {};
        if (CartViewEvent && cart?.currency) {
          this.dispatchEvent(
            new CartViewEvent({
              context: 'dialog',
              cart: CartViewEvent.createCartFromAjaxResponse(cart),
            })
          );
        }
      } catch (error) {
        // Cart notification remains usable even when the informational refresh fails.
      }
    }

    syncCustomCartCount(count) {
      document.querySelectorAll('.f24-header-preview__cart b').forEach((bubble) => {
        bubble.textContent = String(count);
        bubble.hidden = count <= 0;
      });
      document.querySelectorAll('.f24-header-preview__cart').forEach((link) => {
        link.setAttribute('aria-label', count > 0 ? `Warenkorb, ${count} Artikel` : 'Warenkorb');
      });
    }

    close() {
      if (!this.notification) return;
      this.notification.classList.remove('active');
      document.body.removeEventListener('click', this.onBodyClick);
      if (typeof removeTrapFocus === 'function') removeTrapFocus(this.activeElement);
    }

    renderContents(parsedState) {
      this.cartItemKey = parsedState?.key;

      this.getSectionsToRender().forEach((section) => {
        const destination = document.getElementById(section.id);
        const sectionHtml = parsedState?.sections?.[section.id];
        if (!destination || !sectionHtml) return;

        const inner = this.getSectionInnerHTML(sectionHtml, section.selector);
        if (inner === null) return;
        destination.innerHTML = inner;
      });

      if (this.header && typeof this.header.reveal === 'function') this.header.reveal();
      this.open();
    }

    getSectionsToRender() {
      return [
        {
          id: 'cart-notification-product',
          selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
        },
        { id: 'cart-notification-button' },
        { id: 'cart-icon-bubble' },
      ];
    }

    getSectionInnerHTML(html, selector = '.shopify-section') {
      const documentFragment = new DOMParser().parseFromString(html, 'text/html');
      const element = documentFragment.querySelector(selector);
      return element ? element.innerHTML : null;
    }

    handleBodyClick(evt) {
      const target = evt.target;
      if (!(target instanceof Element)) return;
      if (target !== this.notification && !target.closest('cart-notification')) {
        const disclosure = target.closest('details-disclosure, header-menu');
        this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
        this.close();
      }
    }

    setActiveElement(element) {
      this.activeElement = element;
    }
  }

  customElements.define('cart-notification', CartNotification);
}
